import PropTypes from 'prop-types';
import { useBalancedPortValue, useIsBalanced, useAnchorId } from '@/stores/caseStore';
import { useIsIOConnected } from '@/stores/pathwayStore';

/**
 * PortTooltip Component
 * Renders a tooltip that shows the port label and balance values (if available)
 */
const PortTooltip = ({ nodeId, ioName, ioLabel, handleType, position }) => {
  const handleId = `${nodeId}_${handleType}_${ioName}`;
  const balancedValues = useBalancedPortValue(nodeId, handleType, ioName);
  const isConnected = useIsIOConnected(handleId);
  const isAnchored = useAnchorId() === handleId;
  const isBalanced = useIsBalanced();
  const showBalancedValues = isBalanced && balancedValues && (!isConnected || isAnchored);
  
  const positionClass = position === 'right' ? 'right-6' : 'left-6';
  
  return (
    <div className={`absolute ${positionClass} bg-gray-800 text-white text-[10px] px-1.5 py-0.5 rounded opacity-0 group-hover/handle:opacity-100 transition-opacity pointer-events-none z-50`}>
      <div className="whitespace-nowrap">{ioLabel}</div>
      {showBalancedValues && balancedValues.map((value, idx) => (
        <div key={idx} className="whitespace-nowrap">{value}</div>
      ))}
    </div>
  );
};

PortTooltip.propTypes = {
  nodeId: PropTypes.string.isRequired,
  ioName: PropTypes.string.isRequired,
  ioLabel: PropTypes.string.isRequired,
  handleType: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
};

export default PortTooltip;
